import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as surveyConfig from '../space-survey-config'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: surveyConfig.RESOURCE.payload.dimension.partialId,
      partialId: surveyConfig.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    default: false,
    description:
      'When enabled, users are allowed to unlock rooms directly from the room listing rather than requiring an administrator to unlock them.',
    isOptional: false,
    name: 'Allow Standard Users to Unlock Rooms',
    partialId: PartialId.Standard.create('allow_unlock_rooms'),
    type: core.common.value.types.Intrinsic.Boolean,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
